import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const BACKORDERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('BACKORDERS');
export const BACKORDERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	BACKORDERS_CRUD_ACTION_CONSTANTS
);
